import { render, staticRenderFns } from "./OccupationSkills.vue?vue&type=template&id=0c276b36"
import script from "./OccupationSkills.vue?vue&type=script&lang=js"
export * from "./OccupationSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c276b36')) {
      api.createRecord('0c276b36', component.options)
    } else {
      api.reload('0c276b36', component.options)
    }
    module.hot.accept("./OccupationSkills.vue?vue&type=template&id=0c276b36", function () {
      api.rerender('0c276b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/occupation-skill/OccupationSkills.vue"
export default component.exports